/* bios-boot.js — BIOS boot sequence shown over the catalog until the user clicks.
   Right now the BOOT SKIP block at the top short-circuits past the typewriter
   intro for live shoppers — remove that block to restore the full sequence.
   Drives output into #bios-boot-output then hands off to the main catalog. */

/* ── BIOS boot sequence ──────────────────────────────────────────────────── */
(function () {
  var boot = document.getElementById('bios-boot');
  var out  = document.getElementById('bios-boot-output');
  if (!boot || !out) return;

  /* ── BOOT SKIP — remove this block tomorrow to restore the intro ── */
  (function() {
    boot.style.display = 'none';
    document.dispatchEvent(new CustomEvent('bios:boot-end'));
    /* In boot-skip mode fadeToMain() never runs, so _biosLogoClone (created ~940ms
       after the user clicks Experience) is never cleaned up. Listen for bios:portal-done
       (fires after the 940ms clone-creation timeout in bios-portal-onboarding.js) and
       fade the clone out immediately. */
    document.addEventListener('bios:portal-done', function () {
      if (window._biosLogoClone && window._biosLogoClone.parentNode) {
        window._biosLogoClone.style.transition = 'opacity 0.35s ease';
        window._biosLogoClone.style.opacity = '0';
        setTimeout(function() {
          if (window._biosLogoClone && window._biosLogoClone.parentNode)
            window._biosLogoClone.parentNode.removeChild(window._biosLogoClone);
          window._biosLogoClone = null;
        }, 380);
      }
    }, { once: true });
  })();
  return;
  /* ── END BOOT SKIP ── */

  var SID = sessionStorage.getItem('bios_sid') || 'SID-000000-0000';

  /* ── Feature E: returning operator detection ── */
  var lastVisitRaw = localStorage.getItem('bios_lastVisit');
  var returningLine = null;
  if (lastVisitRaw) {
    var elapsed = Date.now() - parseInt(lastVisitRaw, 10);
    var es = Math.floor(elapsed / 1000);
    var em = Math.floor(es / 60); es -= em * 60;
    var eh = Math.floor(em / 60); em -= eh * 60;
    var ed = Math.floor(eh / 24); eh -= ed * 24;
    var ago = ed > 0 ? (ed + 'D ' + eh + 'H AGO') :
              eh > 0 ? (eh + 'H ' + em + 'M AGO') :
              em > 0 ? (em + 'M AGO') : 'JUST NOW';
    returningLine = 'RETURNING OPERATOR DETECTED — LAST SESSION ' + ago;
  }
  localStorage.setItem('bios_lastVisit', String(Date.now()));
  var returningOperator = !!lastVisitRaw;

  /* Feature 8 — restore point detection */
  var restoreRaw  = localStorage.getItem('bios_restore');
  var restoreLine = null;
  if (restoreRaw) {
    var _rp = restoreRaw.split(':');
    restoreLine = 'RESTORE POINT DETECTED — INN-' + String(_rp[1] || '?').padStart(3, '0');
  }

  var SEQ;
  if (returningOperator) {
    /* ── Fast reconnect — node already known to the hivemind ── */
    SEQ = [
      { d:   0, t: 'HIVEMIND UPLINK TERMINAL  //  v2.0.0.2',                        s: 1  },
      { d:   3, t: '────────────────────────────────────────────────',               s: 0  },
      { d:   4, t: returningLine,                                                    s: 0, cls: 'is-hl' },
      restoreLine ? { d: 4, t: restoreLine, s: 0, cls: 'is-hl' } : null,
      { d:   6, t: '',                                                               s: 0  },
      { d:   4, t: '> RECONNECTING  →  45.[ REDACTED ].[ REDACTED ]:8443',      s: 1  },
      { d:   4, t: '  SYN-ACK  ←  RTT 9ms',                                    s: 0  },
      { d:   3, t: '  SESSION RESTORED                         [ OK ]',             s: 0, cls: 'is-hl' },
      { d:   6, t: '',                                                               s: 0  },
      { d:   4, t: '> VERIFYING NODE IDENTITY...',                                  s: 1  },
      { d:   4, t: '  UID         [ REDACTED ]',                                    s: 0, cls: 'is-hl' },
      { d:   3, t: '  CLEARANCE   TIER_0                       [ OK ]',             s: 0, cls: 'is-hl' },
      { d:   8, t: '',                                                               s: 0  },
      { d:   0, t: '────────────────────────────────────────────────',               s: 0, cls: 'is-hl' },
      { d:   6, t: 'ENTITY:  INNOCENCES',                                           s: 1, cls: 'is-project' },
      { d:   4, t: 'SIGNAL:  LIVE',                                                 s: 0, cls: 'is-hl' },
      { d:   4, t: '────────────────────────────────────────────────',               s: 0, cls: 'is-hl' },
      { d:   6, t: '',                                                               s: 0  },
      { d:   4, t: '> BINDING TO HIVEMIND...',                                      s: 1  },
    ].filter(Boolean);
  } else {
    /* ── Full first-contact sequence — establishing node in the network ── */
    SEQ = [
      { d:   0, t: 'HIVEMIND UPLINK TERMINAL  //  v2.0.0.2',                        s: 1  },
      { d:   3, t: '────────────────────────────────────────────────',               s: 0  },
      { d:   3, t: 'INITIALIZING ENDPOINT...',                                       s: 1  },
      { d:   4, t: '  DEVICE_ID   [ REDACTED ]',                                    s: 0, cls: 'is-hl' },
      { d:   3, t: '  LOCATION    [ REDACTED ]',                                    s: 0, cls: 'is-hl' },
      { d:   3, t: '  CLEARANCE   UNVERIFIED',                                      s: 0  },
      returningLine ? { d: 4, t: returningLine, s: 0, cls: 'is-hl' } : null,
      restoreLine   ? { d: 4, t: restoreLine,   s: 0, cls: 'is-hl' } : null,
      { d:   6, t: '',                                                               s: 0  },
      { d:   4, t: '> HANDSHAKE ATTEMPT  →  45.[ REDACTED ].[ REDACTED ]:8443', s: 1  },
      { d:   4, t: '  SYN         →  OK',                                      s: 0  },
      { d:   3, t: '  SYN-ACK     ←  RTT 14ms',                                s: 0  },
      { d:   3, t: '  ACK         →  SESSION ESTABLISHED',                     s: 0  },
      { d:   6, t: '',                                                               s: 0  },
      { d:   4, t: '> AUTHENTICATING NODE...',                                      s: 1  },
      { d:   4, t: '  CERT        [ REDACTED ]              VERIFIED',              s: 0  },
      { d:   3, t: '  CHAIN       [ REDACTED ] → INNCNS.ROOT',                 s: 0  },
      { d:   3, t: '  ACCESS      TIER_0                    [ OK ]',                s: 0, cls: 'is-hl' },
      { d:   6, t: '',                                                               s: 0  },
      { d:   4, t: '> PROBING NETWORK TOPOLOGY...',                                 s: 1  },
      { d:   4, t: '  HOP 1       →  8ms',                                     s: 0  },
      { d:   3, t: '  HOP 2       →  [ REDACTED ]',                            s: 0, cls: 'is-hl' },
      { d:   3, t: '  HOP 3       →  21ms',                                    s: 0  },
      { d:   3, t: '  NODES       [ REDACTED ] / [ REDACTED ] ONLINE',              s: 0, cls: 'is-hl' },
      { d:   3, t: '  PACKET LOSS  0.00%                    [ OK ]',                s: 0  },
      { d:   6, t: '',                                                               s: 0  },
      { d:   4, t: '> RESOLVING IDENTITY...',                                       s: 1  },
      { d:   4, t: '  UID         [ REDACTED ]',                                    s: 0, cls: 'is-hl' },
      { d:   3, t: '  HANDLE      OPERATOR_[ REDACTED ]',                           s: 0, cls: 'is-hl' },
      { d:   3, t: '  STATE       UNKNOWN',                                         s: 0  },
      { d:   8, t: '',                                                               s: 0  },
      { d:   0, t: '────────────────────────────────────────────────',               s: 0, cls: 'is-hl' },
      { d:   6, t: 'ENTITY:  INNOCENCES',                                           s: 1, cls: 'is-project' },
      { d:   4, t: 'SIGNAL:  LIVE',                                                 s: 0, cls: 'is-hl' },
      { d:   3, t: 'STATE:   UNKNOWN',                                              s: 0, cls: 'is-hl' },
      { d:   4, t: '────────────────────────────────────────────────',               s: 0, cls: 'is-hl' },
      { d:   6, t: '',                                                               s: 0  },
      { d:   4, t: '> BINDING TO HIVEMIND...',                                      s: 1  },
    ].filter(Boolean);
  }

  var bootDone      = false;
  var _starfieldRaf = null;

  /* ── Skip boot: keyboard, click, or tap ── */
  function skipBoot() {
    if (bootDone) return;
    bootDone = true;
    document.removeEventListener('keydown', skipBootKey);
    boot.removeEventListener('click',      skipBoot);
    boot.removeEventListener('touchstart', skipBoot);
    fadeToMain();
  }

  function skipBootKey(e) {
    if (e.key === 'Escape' || e.key === ' ' || e.key === 'Enter') skipBoot();
  }

  document.addEventListener('keydown', skipBootKey);
  /* small delay before click/tap skip activates — avoids portal click bleeding through */
  setTimeout(function() {
    boot.addEventListener('click',      skipBoot);
    boot.addEventListener('touchstart', skipBoot, { passive: true });
  }, 300);

  function runLine(idx) {
    if (bootDone) return;
    if (idx >= SEQ.length) {
      showBootProgress();
      return;
    }
    var e = SEQ[idx];
    setTimeout(function () {
      if (bootDone) return;
      var el = document.createElement('div');
      el.className = 'bios-boot-line' + (e.cls ? ' ' + e.cls : '');
      out.appendChild(el);
      out.scrollTop = out.scrollHeight; /* keep latest line visible on mobile */
      if (!e.t || !e.s) { el.textContent = e.t || ''; runLine(idx + 1); return; }
      el.classList.add('is-typing');
      var i = 0, text = e.t, spd = e.s;
      (function ch() {
        if (bootDone) { el.classList.remove('is-typing'); return; }
        if (i < text.length) {
          BiosAudio.typingTick();           /* subtle click per character */
          el.textContent = text.slice(0, ++i);
          out.scrollTop = out.scrollHeight;
          setTimeout(ch, spd + Math.random() * spd * 0.3);
        } else {
          el.classList.remove('is-typing');
          BiosAudio.lineBeep();             /* soft ping when line completes */
          runLine(idx + 1);
        }
      })();
    }, e.d);
  }

  /* ── Boot-sound progress bar — YouTube video drives the duration ── */
  function showBootProgress() {
    if (bootDone) { fadeToMain(); return; }

    var gap = document.createElement('div');
    gap.className = 'bios-boot-line';
    out.appendChild(gap);

    var progEl = document.createElement('div');
    progEl.className = 'bios-boot-line is-hl';
    progEl.textContent = 'LOADING [\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0]   0%';
    out.appendChild(progEl);
    out.scrollTop = out.scrollHeight;

    /* Fixed 4-second progress bar — no external audio sync needed */
    var TOTAL_MS = returningOperator ? 1500 : 4000;
    var W        = 20;
    var start    = Date.now();

    /* milestone tone tracking */
    var _toneHit = { 50: false, 90: false, 100: false };

    (function tick() {
      if (bootDone) { fadeToMain(); return; }
      var pct    = Math.min(100, Math.round((Date.now() - start) / TOTAL_MS * 100));
      var filled = Math.round(pct * W / 100);
      var bar    = '\u2588'.repeat(filled) + '\u00a0'.repeat(W - filled);
      progEl.textContent = 'LOADING [' + bar + '] ' + String(pct).padStart(3) + '%';
      out.scrollTop = out.scrollHeight;
      /* milestone tones */
      if (pct >= 50  && !_toneHit[50])  { _toneHit[50]  = true; BiosAudio.bootTone(50);  }
      if (pct >= 90  && !_toneHit[90])  { _toneHit[90]  = true; BiosAudio.bootTone(90);  }
      if (pct >= 100 && !_toneHit[100]) { _toneHit[100] = true; BiosAudio.bootTone(100); }
      if (pct < 100) {
        requestAnimationFrame(tick);
      } else {
        setTimeout(fadeToMain, 420);
      }
    })();
  }

  /* ── Fade boot screen and reveal main catalog ── */
  function fadeToMain() {
    /* cancel background animations */
    if (_starfieldRaf) { cancelAnimationFrame(_starfieldRaf); _starfieldRaf = null; }
    /* datamosh on boot→main transition */
    datamosh();
    /* remove the persistent logo clone that flew over from the portal */
    if (window._biosLogoClone && window._biosLogoClone.parentNode) {
      window._biosLogoClone.style.transition = 'opacity 0.4s ease';
      window._biosLogoClone.style.opacity    = '0';
      setTimeout(function() {
        if (window._biosLogoClone && window._biosLogoClone.parentNode)
          window._biosLogoClone.parentNode.removeChild(window._biosLogoClone);
        window._biosLogoClone = null;
      }, 420);
    }
    boot.classList.add('is-fading');
    setTimeout(function () {
      boot.style.display = 'none';
      /* signal main-UI reveal — load choreography listens for this (and bios:portal-dismissed) */
      document.dispatchEvent(new CustomEvent('bios:boot-end'));

      /* attempt welcome audio — autoplay may be blocked; fallback waits for gesture */
      var welcome = document.getElementById('bios-welcome');
      if (welcome) {
        welcome.play().catch(function () {
          function onGesture() {
            welcome.play().catch(function () {});
            document.removeEventListener('click',      onGesture);
            document.removeEventListener('keydown',    onGesture);
            document.removeEventListener('touchstart', onGesture);
          }
          document.addEventListener('click',      onGesture, { once: true, passive: true });
          document.addEventListener('keydown',    onGesture, { once: true, passive: true });
          document.addEventListener('touchstart', onGesture, { once: true, passive: true });
        });
      }
      /* Mobile: show swipe hint in the terminal prompt area */
      if (isTouchDevice) {
        var typedElM  = document.getElementById('bios-typed');
        var caretElM  = document.getElementById('bios-caret');
        var searchElM = document.getElementById('bios-search');
        var ghostElM  = document.getElementById('bios-cmd-ghost');
        if (typedElM)  typedElM.textContent = 'SWIPE \u2195  TAP TO OPEN';
        if (caretElM)  caretElM.style.display = 'none';
        if (ghostElM)  ghostElM.classList.add('is-hidden'); /* hide ghost while swipe hint shows */
        if (searchElM) {
          searchElM.setAttribute('tabindex', '-1');
        }
        document.addEventListener('touchstart', function clearHint() {
          if (typedElM) typedElM.textContent = '';
          if (caretElM) caretElM.style.display = '';
          if (ghostElM) ghostElM.classList.remove('is-hidden');
          if (searchElM) searchElM.removeAttribute('tabindex'); /* restore terminal search — user can now tap footer to type commands */
          document.removeEventListener('touchstart', clearHint);
        }, { once: true, passive: true });
      }
    }, 400);
  }

  /* ── ASCII warp-speed starfield background ── */
  function initStarfield() {
    var canvas = document.getElementById('bios-boot-starfield');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
    var W = canvas.width, H = canvas.height;
    var CX = W / 2, CY = H / 2;
    var MAXR = Math.sqrt(CX * CX + CY * CY) + 20;
    var N = 220;
    var CHARS = ['.', '.', '+', '+', '*', '\u2736'];

    function mkStar(scatterFull) {
      var angle = Math.random() * Math.PI * 2;
      var r     = scatterFull ? Math.random() * MAXR * 0.85 : Math.random() * 8;
      var spd   = 0.6 + Math.random() * 3.2;
      return { angle: angle, r: r, spd: spd };
    }

    var stars = [];
    for (var i = 0; i < N; i++) stars.push(mkStar(true));

    /* Dust particles — mirror portal canvas so the handoff to [system] feels continuous */
    var DUST_N = 85;
    var dust   = [];
    function mkDust() {
      return {
        x:  Math.random() * W,
        y:  Math.random() * H,
        vx: (Math.random() - 0.5) * 0.32,
        vy: -(0.10 + Math.random() * 0.24),
        r:  0.4 + Math.random() * 1.1,
        a:  0.04 + Math.random() * 0.13
      };
    }
    for (var di = 0; di < DUST_N; di++) dust.push(mkDust());

    ctx.font = '11px Mononoki,ui-monospace,"Courier New",monospace';
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';

    (function frame() {
      if (bootDone) return;
      ctx.clearRect(0, 0, W, H);

      /* stars */
      for (var i = 0; i < N; i++) {
        var s = stars[i];
        s.r += s.spd;
        if (s.r > MAXR) { stars[i] = mkStar(false); continue; }
        var sx    = CX + Math.cos(s.angle) * s.r;
        var sy    = CY + Math.sin(s.angle) * s.r;
        var depth = s.r / MAXR;
        var ci    = Math.min(CHARS.length - 1, Math.floor(depth * CHARS.length));
        var alpha = (depth * 0.72 + 0.07).toFixed(2);
        ctx.fillStyle = 'rgba(155,146,132,' + alpha + ')';
        ctx.fillText(CHARS[ci], sx, sy);
      }

      /* dust */
      for (var di = 0; di < DUST_N; di++) {
        var d = dust[di];
        d.x += d.vx; d.y += d.vy;
        if (d.y < -4) { d.y = H + 4; d.x = Math.random() * W; }
        if (d.x < -4) d.x = W + 4; else if (d.x > W + 4) d.x = -4;
        ctx.beginPath();
        ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(195,182,158,' + d.a.toFixed(3) + ')';
        ctx.fill();
      }

      _starfieldRaf = requestAnimationFrame(frame);
    })();
  }

  /* initPlasmaMorph removed — panel replaced by centered hivemind boot sequence */

  /* ── Japanese katakana glitch on the logo clone during boot ── */
  var _KANA = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンガギグゲゴザジズゼゾダデドバビブベボ'.split('');

  function _kanaGlitch() {
    if (bootDone) return;
    var clone = window._biosLogoClone;
    if (!clone) return;
    var pre = clone.querySelector('.bios-portal-ascii-name');
    if (!pre) return;
    var orig = pre.textContent;

    /* first corrupt pass */
    (function burst(pass) {
      if (bootDone || !pre) return;
      var chars = orig.split('');
      var hits = 5 + Math.floor(Math.random() * 9);
      for (var i = 0; i < hits; i++) {
        var idx = Math.floor(Math.random() * chars.length);
        if (chars[idx] !== '\n' && chars[idx] !== ' ') {
          chars[idx] = _KANA[Math.floor(Math.random() * _KANA.length)];
        }
      }
      pre.textContent = chars.join('');
      /* restore then optionally fire a second micro-burst */
      setTimeout(function() {
        if (!pre || bootDone) return;
        pre.textContent = orig;
        if (pass < 2 && Math.random() > 0.4) {
          setTimeout(function() { burst(pass + 1); }, 60 + Math.random() * 80);
        }
      }, 80 + Math.random() * 140);
    })(0);
  }

  function _scheduleKanaGlitches() {
    /* 5 glitch events spread across the boot — early, mid, late, and two near-random */
    var delays = [
      320  + Math.random() * 200,   /* during text phase */
      1100 + Math.random() * 400,   /* progress bar early */
      2200 + Math.random() * 600,   /* progress bar mid */
      3600 + Math.random() * 800,   /* progress bar late */
      5000 + Math.random() * 1200,  /* final stretch */
    ];
    delays.forEach(function(d) {
      setTimeout(_kanaGlitch, d);
    });
  }

  /* ── Start boot — wait for portal to be dismissed first ── */
  if (sessionStorage.getItem('bios_portal_choice')) {
    initStarfield();
    runLine(0);
    _scheduleKanaGlitches();
  } else {
    document.addEventListener('bios:portal-done', function () {
      initStarfield();
      initPlasmaMorph();
      runLine(0);
      _scheduleKanaGlitches();
    }, { once: true });
  }
})();
